import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl +'/system' 

export default {
	/**
	 * 获取登录日志列表
	**/
	getLoginLog(params){
		params = commonJs.obj.removeNullKey(params)
		return request({
			url: BASE_URL+'/login/log',
			method:'get',
			params
		})
	},
	/**
	 * 删除登录日志
	**/
	LoginLogDel(data){
		return request({
			url: BASE_URL+'/login/log',
			method:'DELETE',
			data
		})
	}
}